import classNames from 'classnames'
import type { FC} from 'react'
import { cloneElement, isValidElement } from 'react'
import type { IconProps, NamedIconComponentType } from '../icon'
import { IconSize } from '../icon'
import { Blob01 } from '../shape'
import styles from './IconBlob.module.scss'
import type { IconBlobProps, IconBlobSizeType } from './types'
import { IconBlobSize, IconBlobType } from './types'

const mapperSizes: Map<IconBlobSizeType, IconSize> = new Map([
  [IconBlobSize.xlarge, IconSize.xlarge],
  [IconBlobSize.large, IconSize.large],
  [IconBlobSize.medium, IconSize.medium],
  [IconBlobSize.small, IconSize.small],
])

const IconBlob: FC<IconBlobProps> = ({
  className = '',
  type = IconBlobType.marketing,
  size = IconBlobSize.medium,
  icon,
  blob = Blob01,
}) => {
  const Blob = blob
  const iconSize = mapperSizes.get(size) || IconSize.medium
  let IconComponent
  if (icon) {
    if (isValidElement<IconProps>(icon)) {
      IconComponent = cloneElement(icon, {
        size: iconSize,
      })
    } else if (isValidElement<NamedIconComponentType>) {
      const Icon = icon
      IconComponent = <Icon size={iconSize} />
    }
  }

  return (
    <div
      className={classNames(styles['pintxo-icon-blob'], className)}
      data-size={size}
      data-type={type}
    >
      <div className={styles['pintxo-icon-blob__shape']}>{Blob && <Blob />}</div>
      <div className={styles['pintxo-icon-blob__icon']}>{IconComponent && IconComponent}</div>
    </div>
  )
}

export default IconBlob
